import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core/lib/utils";
var getMainStyle = function getMainStyle(props) {
  var _getThemeData = getThemeData(props, "common"),
    primary = _getThemeData.primary;
  return css([".ant-breadcrumb{font-size:14px;> span:last-child .ant-breadcrumb-link{color:", ";}}"], primary);
};
export default createStyleComponent("breadcrumb", getMainStyle);